<template>
	<div>
		<b-modal title="Add a channel" ref="modal" :busy="loading>0" hide-footer>
			<b-input v-model="filter" placeholder="Search..." class="mb-2"/>
			<b-form-row cols-lg="4" align-v="stretch">
				<b-col v-for="(service, idx) in services.filter(s => filter ? s.name.toLowerCase().startsWith(filter.toLowerCase()) : true)" :key="idx" align-self="stretch" class="mb-2">
					<b-button block class="h-100" @click="openAdd(service, $event)">
						<img v-if="service.icon_url" class="rounded-circle" :src="service.icon_url" style="max-width: 40px" /><br />
						{{service.name}}
					</b-button>
				</b-col>
			</b-form-row>
			<b-alert variant="danger" :show="!!error">{{error}}</b-alert>
		</b-modal>
		<channel-edit-modal ref="editModal"></channel-edit-modal>
	</div>
</template>

<style>
	.vbt-autocomplete-list {
		z-index:  1055;
	}
</style>

<script>
import ChannelEditModal from './Edit.vue';

export default {
	name: 'ChannelAddModal',
	components: {
		ChannelEditModal,
	},
	data() { return {
		services: [],
		loading: 0,
		error: null,
		filter: '',
	}},
	methods: {
		load(promise) {
			this.error = null;
			this.loading++;
			promise.catch(err => {
				this.error = err&&err.error||err.toString();
			}).finally(() => {
				this.loading--;
			});
			return promise;
		},
		async loadServices() {
			this.services = (await this.load(this.$api.get('services'))).filter(s => s.capabilities.indexOf('chat') != -1);
		},
		show() {
			this.loadServices();
			this.error = null;
			this.$refs.modal.show();
		},
		openAdd(service, event) {

			this.$refs.modal.hide();
			if(service.auth && service.auth.url && !event?.shiftKey)
				return window.open(service.auth.url, 'Authenticate', `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,width=${service.auth.width||700},height=${service.auth.height||600}`);

			this.$refs.editModal.show(service.id, null, service.name, service.protocol_name);
		},
	}
};
</script>
